/**
 * Shared utilities for visually highlighting active filter controls
 * across all list pages (Sales, Clients, Contracts, Agencies, Agents).
 *
 * Usage:
 *   <Input className={cn("pl-10", activeFilterClass(searchTerm))} ... />
 *   <SelectTrigger className={activeFilterClass(value !== "all" ? value : "")}> ... </SelectTrigger>
 */

// Tailwind classes applied to inputs / select triggers that currently have a filter value.
// Blue tinted border + soft background to make the active state obvious without being noisy.
export const ACTIVE_FILTER_CLASS =
  "border-blue-500 bg-blue-50 ring-1 ring-blue-200 focus:ring-blue-300";

/**
 * Returns the active-filter class string when `value` is "truthy" (filter is applied),
 * or an empty string when the filter is inactive.
 *
 * Treats "", null, undefined, "all", and "__ALL__" as inactive.
 */
export const activeFilterClass = (value) => {
  if (value === null || value === undefined) return "";
  if (typeof value === "string") {
    const v = value.trim();
    if (v === "" || v === "all" || v === "__ALL__") return "";
    return ACTIVE_FILTER_CLASS;
  }
  // booleans / numbers / non-empty objects → active
  return value ? ACTIVE_FILTER_CLASS : "";
};

/**
 * Boolean helper — true when the filter value should be considered active.
 */
export const isFilterActive = (value) => activeFilterClass(value) !== "";
